import * as Constants from '@/constants'

// Determines if a subscription is pending a change or cancellation, since those states can break things like FindStoreProducts
export const isSubscriptionPendingChange = subscription => {
  if (!subscription) {
    return false
  }

  return (
    subscription.status === Constants.SubscriptionDetailPendingCancel ||
    subscription.status === Constants.SubscriptionDetailPendingProductChange
  )
}

// Determines if a subscription EXISTS and is NOT a web purchase
// Pardon the negative check, but this is being used to hide some features / prevent service calls...
// ...and in some case it's simply easier to check if a subscription exists from another platform to put up those blockers
export const isSubscriptionFromNonWebStore = subscription => {
  // isNaN because apple subs are store: 0, which is falsey
  if (!subscription || isNaN(subscription?.store)) {
    return false
  }

  return subscription.store !== Constants.WebSubscriptionStore
}
